module.exports = __webpack_public_path__ + "static/hero-small-91b63feaef5fdbd55b544270c9e06ffc.jpg";